import React, { useEffect } from "react";
import Table from "../../../../../common/element/Table";
import Tooltip from "../../../../../common/element/Tooltip";
import Tag from "../../../../../common/element/Tag";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import { AddSpecificProviderData } from "../../../../../redux/classes/AdminContractor/SpecificProvider";
import Button from "../../../../../common/element/Buttons";
import CryptoJS from "crypto-js";
import { encryptId } from "../../../../../common/encryptDecrypt/encryptdecrypt";
const { Tr, Th, Td, THead, TBody } = Table;
const ViewAllList = ({ providersData, filterData, handleSort, updateData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSpecificData = (item) => {
    dispatch(AddSpecificProviderData(""));
    updateData(item);
    navigate(
      `specific-provider/${encodeURIComponent(
        encryptId(item?.organisation_id)
      )}`
    );
  };

  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th className="w-72">
                <span
                  className="flex items-center gap-1"
                  onClick={() => handleSort("trading_name")}
                >
                  Provider name
                  <svg
                    className={`transform ${filterData?.sort === "trading_name" &&
                      filterData?.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th>
                <span
                  className="flex items-center gap-1"
                  onClick={() => handleSort("provider_type_name")}
                >
                  Provider type
                  <svg
                    className={`transform ${filterData?.sort === "provider_type_name" &&
                      filterData?.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>

              <Th>Services</Th>
              <Th>ABN/NZBN</Th>
              <Th>State</Th>
              <Th className="w-60">
                <span
                  className="flex items-center gap-1"
                  onClick={() => handleSort("phone")}
                >
                  Contact no.
                  <svg
                    className={`transform ${filterData?.sort === "phone" &&
                      filterData?.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th>
                <span
                  className="flex items-center gap-1"
                // onClick={() => handleSort("date")}
                >
                  Renewal date
                  {/* <svg
                    className={`transform ${
                      filterData?.sort === "date" && filterData?.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg> */}
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {providersData &&
              providersData?.map((item, index) => {
                // Usage example
                const encryptedId = encryptId(item?.organisation_id);

                return (
                  <Tr
                    key={index}
                    onClick={() => handleSpecificData(item)}
                    className={"cursor-pointer"}
                  >
                    {/* <Td>-</Td> */}
                    <Td>
                      <div className="w-72 threeDotLine">
                        <Link
                          to={`specific-provider/${encodeURIComponent(encryptedId)}`}
                          className=""
                          onClick={() => handleSpecificData(item)}
                        >
                          <Tooltip title={item?.trading_name || ""}>
                            <span className="">
                              {item?.trading_name || "-"}
                            </span>
                          </Tooltip>
                        </Link>
                      </div>
                    </Td>

                    <Td>{item?.provider_type_name ? item?.provider_type_name : "-"}</Td>
                    <Td>{item?.meta_value_one ? item?.meta_value_one : "-"}</Td>
                    <Td>{item?.abn_nzbn ? item?.abn_nzbn : "-"}</Td>
                    <Td>{item?.state_name ? item?.state_name : "-"}</Td>
                    <Td ><div className="noti-newwrap w-8/12" > {item?.phone ? item?.phone : "-"}</div></Td>

                    {/* <Td>
                      <Tag className="text-gray-700 bg-gray-100">-</Tag>
                    </Td> */}

                    <Td>{item?.next_renewal_date ? moment(new Date(item?.next_renewal_date)).format("DD/MM/YYYY") : "-"}</Td>
                  </Tr>
                );
              })}

          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};

export default ViewAllList;
